import React from 'react';

interface Solution {
    id: number;
    title: string;
    description: string;
    link: string;
}

const solutions: Solution[] = [
    {
        id: 1,
        title: 'Для профессиональных учебных заведений по всей России',
        description: '',
        link: 'https://www.pride.ru/partners/for-univer'
    },
    {
        id: 2,
        title: 'Для машиностроения, автомобилестроения, обслуживания авиационной техники, железных дорог, добычи природных ресурсов',
        description: '',
        link: 'https://www.pride.ru/partners/for-prom'
    },
    {
        id: 3,
        title: 'Для обслуживания легковых автомобилей, грузовой и тяжелой техники',
        description: '',
        link: 'https://www.pride.ru/partners/for-auto'
    },
    {
        id: 4,
        title: 'Для СТО и предприятий',
        description: 'Индивидуальный подбор инструмента и создание уникальных комплектаций наборов под конкретные нужды и технологические операции',
        link: 'https://www.pride.ru/partners/for-sto'
    }
];

const PartnerSolutions: React.FC = () => {
    return (
        <div className="decisions">
            <div className="container">
                <div className="row gx-md-6 gy-3 gx-svm-3 gy-sm-6 decisions__row">
                    {solutions.map((solution) => (
                        <div key={solution.id} className="col-lg-6 col-sm-12 decisions__item">
                            <div className="d-flex flex-column align-items-start decisions__i-body">
                                <div className="fw-bold decisions__i-title">
                                    {solution.title}
                                </div>
                                {solution.description && (
                                    <p className="decisions__i-text">
                                        {solution.description}
                                    </p>
                                )}
                                <a href={solution.link} className="bs-link decisions__i-link">
                                    Подробнее
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PartnerSolutions;